<template>
  <div class="popularType-main newUi">
    <div class="popularType_content flex">
      <div class="content_left flexColumn">
        <div class="content_style" style="height: 100%;">
          <div class="style_title">
            近期影像资料
          </div>
          <div class="style_content">
            <div style="width: 100%;height: 98%;overflow: auto;">
              <el-row style="margin:15px 5px" v-for="(item, index) in dataList" :key="index">
                <video v-if="item.ext == '.mp4'" style="width: 100%;height: 200px"
                  :src="$store.state.baseUrl + item.fpath" autoplay muted controls="controls" wmode="Opaque"
                  disablePictureInPicture="true" controlslist="nodownload noremoteplayback"></video>
                <el-image v-else style="width: 100%; height: 200px" :src="$store.state.baseUrl + item.fpath"
                  fit="fill"></el-image>
                <div style="text-align: center;line-height: 30px;background-color: #376D97;margin-top: -4px;">
                  {{ item.fname }}
                </div>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="content_center flexColumn" style="padding: 10px;justify-content: space-between;">
        <div class="content_style" style="height: 100%;">
          <div class="style_title2">
            隐蔽影像资料滚动显示
          </div>
          <div class="style_content">
            <div style="height: 100%; width: 100%; justify-content: space-between;" class="flex">
              <div style="height: 100%; width: 25%;">
                <div class="content_style" style="height: 100%;">
                  <div>
                    <el-aside width="100%" class="elAside">
                      <zTreeZN :zNodes="zNodes" @getData="getDataList" @addFileZtree="addFileZtree" :options="{
                        id: 'id',
                        pid: 'parentid',
                        label: 'tname',
                        zTreeId: 'PdeptTree',
                        delType: {
                          add: false,
                          update: false,
                          del: false,
                          addFile: upOrdelUserAuthority,
                        },
                      }" ref="zTree" />
                    </el-aside>
                  </div>
                </div>
              </div>
              <div style="height: 100%; width: 74%;">
                <div class="content_style" style="height: 100%;">
                  <div>
                    <el-table :data="dataList" highlight-current-row height="700" :header-cell-style="{
                      background: '#71A5D0',
                      color: '#fff',
                      textAlign: 'center',
                    }" :cell-style="{ textAlign: 'center' }">
                      <el-table-column type="index" label="序号">
                      </el-table-column>
                      <el-table-column prop="fname" label="文件名称">
                        <template slot-scope="scope">
                          <el-button size="small" type="text" style="color: #fff;" @click="lookImage(scope.row)">{{
                            scope.row.fname }}</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" label="操作">
                        <template slot-scope="scope">
                          <el-button size="small" type="primary" plain @click="feedbackChange(scope.row)">反馈</el-button>
                          <el-button v-if="downUserAuthority" size="small" type="primary" plain
                            @click="downChange(scope.row)">下载</el-button>
                          <el-button v-if="upOrdelUserAuthority || scope.row.createuserid == uid" size="small"
                            type="warning" plain @click="delChange(scope.row.id)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_left flexColumn">
        <div class="content_style" style="height: 100%;">
          <div class="style_title">
            问题反馈清单
          </div>
          <div class="style_content">
            <el-table :data="feedbackList" highlight-current-row height="85%" :header-cell-style="{
              background: '#71A5D0',
              color: '#fff',
              textAlign: 'center',
            }" :cell-style="{ textAlign: 'center' }">
              <el-table-column prop="title" label="标题">
                <template slot-scope="scope">
                  <el-button size="small" type="text" class="wirte" @click="questionChange(scope.row)"
                    :title="scope.row.title">{{
                      scope.row.title }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="username" label="指定回复人">
                <template slot-scope="scope">
                  {{scope.row.replayusers.map(i => i.user04).join('、')}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 新增文件 -->
      <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="新增节点文件" :visible.sync="ADDFileShow"
        width="50%" height="50%" :before-close="handleClose" class="inputStyle">
        <el-form :model="processForm" :rules="processRule" label-width="120px" ref="processForm">
          <el-form-item label="楼栋号" prop="val1">
            <el-input v-model="processForm.val1" placeholder="必填，文本，手动输入"></el-input>
          </el-form-item>
          <el-form-item label="影像资料描述" prop="val2">
            <el-input v-model="processForm.val2" placeholder="必填，文本，手动输入"></el-input>
          </el-form-item>
          <el-form-item label="文件" prop="fileList">
            <el-upload class="upload-demo" accept=".mp4,.jpg,.png" multiple :action="actionUrl"
              :file-list="processForm.fileList" :before-upload="beforeUpload" :on-change="handleChange">
              <el-button size="small" style="width: 150px;color: #333;">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="2" :offset="22">
            <el-button type="primary" @click="submitUpdata('processForm')">确定</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 反馈 -->
      <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="反馈" :visible.sync="feedbackShow"
        width="55%" height="50%" :before-close="handleClose" class="inputStyle">
        <el-form :model="feedbackForm" :rules="feedbackRule" ref="Updatefeedback" label-width="200px"
          class="demo-ruleForm mar-r80" style="padding-right: 60px;">
          <el-form-item label="关联文件：">
            <el-input disabled v-model="feedbackForm.fileName" placeholder="必填，文本，手动输入"></el-input>
          </el-form-item>
          <el-form-item label="问题反馈清单标题：" prop="title">
            <el-input type="text" maxlength="30" v-model="feedbackForm.title" placeholder="请输入标题，限制30个汉字"></el-input>
          </el-form-item>
          <el-form-item label="问题反馈清单内容：" prop="strcount">
            <ckediter4 ref="ck" v-model="feedbackForm.strcount" :disable="false"></ckediter4>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="2" :offset="21">
            <el-button type="primary" style="width: 100%;" @click="submitfeedback('Updatefeedback')">确定</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 反馈问题回复预览 -->
      <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="问题反馈清单预览"
        :visible.sync="ShowQuestion" width="80%" height="50%">
        <el-form :model="questionForm" label-width="150px" ref="addForm2" style="padding-right: 60px;">
          <el-form-item label="关联文件：">
            <div>
              {{ questionForm.ywprojectfile != null ? questionForm.ywprojectfile.fname : "关联文件已被删除" }}
            </div>
          </el-form-item>
          <el-form-item label="问题反馈清单标题：">
            <div>{{ questionForm.title }}</div>
          </el-form-item>
          <el-row style="padding:0px">
            <el-col :span="6">
              <el-form-item label="清单状态：">
                <div>{{ questionForm.strstatus }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="关闭时间：">
                <div>
                  {{ questionForm.status != 2 ? "未关闭" : questionForm.colsetime }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding:0px;margin-top: 20px;" v-for="(item, index) in questionForm.disposelsit" :key="index">
            <el-col :span="12">
              <el-row style="padding:0px">
                <el-col :span="12">
                  <el-form-item :label="index == 0 ? '发起人：' : '追问人：'">
                    <div>{{ item.fbusername }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="index == 0 ? '发起时间：' : '追问时间：'">
                    <div>{{ item.fbdate }}</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="问题反馈清单内容：">
                <ckediter4 v-model="item.fbcontent" :disable="true"></ckediter4>
              </el-form-item>
            </el-col>

            <template v-if="questionForm.creatuser == uid && replyUserAuthority">
              <el-col :span="12">
                <el-row style="padding:0px">
                  <el-col :span="12">
                    <el-form-item label="回复人：">
                      <div>{{ item.disusername }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="回复时间：">
                      <div>
                        {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="回复内容：" prop="disposecontent">
                  <ckediter4 ref="ck" v-model="item.disposecontent"
                    :disable="item.disposecontent != null ? true : false">
                  </ckediter4>
                </el-form-item>
              </el-col>
              <el-col :span="2" :offset="22"
                v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length">
                <el-button type="primary" style="width: 100%;" @click="questionBtn(item, false, index)">确定</el-button>
              </el-col>
              <el-col :span="4" :offset="20" v-else>
                <div style="float: right;" v-if="index + 1 == questionForm.disposelsit.length">
                  <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                  <el-button type="primary" v-show="zwStatus == true"
                    @click="questionBtn(item, true, index)">关闭问题</el-button>
                </div>
              </el-col>
            </template>
            <template v-else>
              <template
                v-if="!(index + 1 == questionForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null">
                <el-col :span="12">
                  <el-row style="padding:0px">
                    <el-col :span="12">
                      <el-form-item label="回复人：">
                        <div>{{ item.disusername }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="回复时间：">
                        <div>
                          {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate
                          }}
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="回复内容：" prop="disposecontent">
                    <ckediter4 ref="ck" v-model="item.disposecontent"
                      :disable="item.disposecontent != null ? true : questionDisable">
                    </ckediter4>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="20"
                  v-if="questionForm.creatuser == uid && index + 1 == questionForm.disposelsit.length">
                  <div style="float: right;">
                    <el-button style="color:#333" @click="continueBtn()">继续追问</el-button>
                    <el-button type="primary" v-show="zwStatus == true"
                      @click="questionBtn(item, true, index)">关闭问题</el-button>
                  </div>
                </el-col>
                <el-col :span="2" :offset="22" v-else>
                  <el-button v-if="item.disusername == null && index + 1 == questionForm.disposelsit.length"
                    type="primary" style="width: 100%;" @click="questionBtn(item, false, index)">确定</el-button>
                </el-col>
              </template>
            </template>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="zwStatus == false">
              <el-form-item label="问题反馈清单内容:">
                <ckediter4 ref="ck2" v-model="newFeedback.fbcontent" :disable="zwStatus"></ckediter4>
                <el-col :span="2" :offset="21">
                  <el-button style="margin-top:10px" type="primary" @click="questionBtn1()">确定</el-button>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>

      <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="预览" :visible.sync="ShowImage"
        :before-close="handleClose" width="50%" height="50%">
        <div>
          <video v-if="videosrc.length" class="imgorimgstyle" controls autoplay muted disablePictureInPicture="true"
            controlslist="nodownload noremoteplayback">
            <source :src="videosrc" type="video/mp4" />
          </video>
          <el-image class="imgorimgstyle" v-else :src="Imagesrc"></el-image>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import zTreeZN from "@//components/zTreeZN.vue";
import ckediter4 from "@/components/ck.vue";
import {
  GetywproTreeList,
  GetYwFilesList,
  GetYWProUserAuth,
  AddYwFilesWithTree,
  DelYwFilesList,
  AddYwFeedback,
  GetYwFeedbackList,
  YWFbAskedAndReply,
} from "@/setAxios.js";
import { download } from "@/tools/tool";
export default {
  name: "popularType",
  components: { zTreeZN, ckediter4 },
  data() {
    return {
      uid: Number(localStorage.getItem("id")),
      id: null,
      zNodes: null,
      loading: false,
      ADDFileShow: false,
      dataList: [],
      processForm: {
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
        fileList: [],
      },
      processRule: {
        val1: [{ required: true, message: "请输入", trigger: "change" }],
        val2: [{ required: true, message: "请输入", trigger: "blur" }],
        val3: [{ required: true, message: "请输入", trigger: "blur" }],
        val4: [{ required: true, message: "请输入", trigger: "blur" }],
        val5: [{ required: true, message: "请输入", trigger: "blur" }],
        fileList: [
          {
            validator: (rule, value, callback) => {
              const valid = value.length > 0;
              if (valid) {
                return callback();
              } else {
                return callback(new Error(rule.message));
              }
            },
            required: true,
            message: "请上传文件",
          },
        ],
      },
      actionUrl: this.$store.state.baseUrl,
      // 人员权限
      upOrdelUser: [],
      downUser: [],
      replyUser: [],
      // 反馈
      feedbackList: [],
      feedbackShow: false,
      feedbackForm: {},
      feedbackRule: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        strcount: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      ShowQuestion: false,
      questionForm: {
        ywprojectfile: {},
      },
      questionDisable: false,
      replayStatus: false,
      zwStatus: true,
      newFeedback: {},
      ShowImage: false,
      Imagesrc: "",
      videosrc: "",
    };
  },
  computed: {
    upOrdelUserAuthority() {
      return this.upOrdelUser.includes(Number(localStorage.getItem("id")));
    },
    downUserAuthority() {
      return this.downUser.includes(Number(localStorage.getItem("id")))
    },
    replyUserAuthority() {
      return this.replyUser.includes(Number(localStorage.getItem("id")))
    },
  },
  created() {
    this.GetywproTree();
    this.GetYWProUserAuthUser(8);
    this.GetYWProUserAuthUser(9);
    this.GetFeedbackList();
    this.getDataList();
  },
  methods: {
    // 文件树
    GetywproTree() {
      this.loading = true;
      GetywproTreeList({
        params: { xid: this.$store.state.xid, type: 5 },
      }).then((res) => {
        this.zNodes = res.Data;
        this.loading = false;
      });
    },
    // 获取列表
    async getDataList(ids) {
      this.loading = true;
      let params = {
        fname: "",
        xid: this.$store.state.xid,
        type: 4,
        treeid: ids,
        pageindex: 1,
        pageSize: 99999,
      };
      let fd = new FormData();
      for (var key in params) {
        fd.append(key, params[key]);
      }
      let res = await GetYwFilesList(fd);
      this.loading = false;
      if (res.Data && res.Data.length > 0) {
        res.Data.forEach((item) => {
          item.fname = this.removeDateComprehensive(item.fname);
        });
      }
      this.dataList = res.Data.length > 0 ? res.Data : [];
    },

    //移除时间
    removeDateComprehensive(filename) {
      return filename.replace(/_\d{4}[-/.]?\d{2}[-/.]?\d{2}([_\sT]\d{2}[:.-]?\d{2}[:.-]?\d{2})?(_|$)/g, '_');
    },

    // 获取项目模块人员权限
    GetYWProUserAuthUser(type) {
      let params = {
        xid: this.$store.state.xid,
        type: type,
      };
      GetYWProUserAuth({ params }).then((res) => {
        if (res.Data) {
          if (type == 8) {
            this.upOrdelUser =
              res.Data.insertuids != null
                ? res.Data.insertuids.split(",").map(Number)
                : [];
            this.downUser =
              res.Data.downloaduids != null
                ? res.Data.downloaduids.split(",").map(Number)
                : [];
          } else {
            this.replyUser =
              res.Data.replyuids != null
                ? res.Data.replyuids.split(",").map(Number)
                : [];
          }
        }
      });
    },
    addFileZtree(id, data) {
      this.ADDFileShow = true;
      this.id = data.id;
      this.processForm.fileList = [];
    },
    // 添加文件
    submitUpdata(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fd = new FormData();
          this.processForm.fileList.forEach((file) => {
            fd.append(`${file.name}^@^${file.versions}`, file.raw);
          });
          fd.append("xid", this.$store.state.xid);
          fd.append("type", 4);
          fd.append("targetId", this.id);
          for (var key in this.processForm) {
            fd.append(key, this.processForm[key]);
          }
          AddYwFilesWithTree(fd).then((res) => {
            if (res.Code != 0) {
              this.$message.success("上传成功");
              this.getDataList();
              this.processForm = {
                val1: "",
                val2: "",
                val3: "",
                val4: "",
                val5: "",
                fileList: [],
              };
              this.ADDFileShow = false;
              this.$refs.upload.clearFiles();
            } else {
              this.$message.error(res.Message);
            }
          });
        } else {
          this.$message.error("验证失败！");
          return false;
        }
      });
    },
    handleChange(file, fileList) {
      // this.fileList = fileList;
      this.processForm.fileList = fileList;
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      var suffixs = ["mp4", "jpg", "png"];
      if (suffixs.indexOf(suffix) == -1) {
        this.$message({
          message: "上传文件仅支持图片和视频格式!",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    // 预览
    lookImage(row) {
      this.ShowImage = true;
      let arr = row.fpath.substr(row.fpath.lastIndexOf(".")).toLowerCase()
      if (arr == ".mp4") {
        this.videosrc = this.actionUrl + row.fpath;
      } else {
        this.Imagesrc = this.actionUrl + row.fpath;
      }
    },
    handleClose(done) {
      done();
      this.videosrc = "";
      this.Imagesrc = "";
    },
    // 反馈
    feedbackChange(data) {
      if (this.replyUser.length == 0) {
        this.$message.warning("请联系管理员设置指定回复人！")
        return false;
      }
      this.feedbackShow = true;
      this.feedbackForm = {
        fileId: data.id,
        fileName: data.fname,
        title: "",
        strcount: "",
      };
    },
    GetFeedbackList() {
      let params = {
        searchword: "",
        projectid: this.$store.state.xid,
        type: 4,
        status: -1,
        pageindex: 1,
        pagesize: 99999,
        treeid: 0,
      };
      let fd = new FormData();
      for (var key in params) {
        fd.append(key, params[key]);
      }
      GetYwFeedbackList(fd).then((res) => {
        this.feedbackList = res.Data.filter((el) => el.strstatus != "已关闭");
      });
    },
    submitfeedback(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.feedbackForm.strcount.length > 0) {
          let fd = new FormData();
          this.feedbackForm.strcount = this.$refs.ck.ckeditor.getData();
          fd.append("projectid", this.$store.state.xid);
          fd.append("type", 4);
          fd.append("fileId", this.feedbackForm.fileId);
          fd.append("title", this.feedbackForm.title);
          fd.append("strcount", this.feedbackForm.strcount);
          AddYwFeedback(fd).then((res) => {
            if (res.Code != 0) {
              this.GetFeedbackList();
              this.$message.success("上传成功");
              this.feedbackForm = {};
              this.feedbackShow = false;
            } else {
              this.$message.error(res.Message);
            }
          });
        } else {
          this.$message.error("验证失败！");
          return false;
        }
      });
    },
    questionChange(data) {
      this.questionForm = data;
      if (
        this.replyUser.includes(Number(localStorage.getItem("id"))) === true ||
        this.questionForm.creatuser === Number(localStorage.getItem("id"))
      ) {
        //状态回复设置
        if (data.status === 0) {
          //
          this.replayStatus = false;
          this.questionDisable = false;
          this.submitStatus = false;
        } else if (data.status === 1) {
          //回复待确认
          this.replayStatus = true;
          this.questionDisable = true;
          this.submitStatus = true;
          this.zwStatus = true;
        } else if (data.status === 2) {
          //已关闭
          this.submitStatus = true;
          this.questionDisable = true;
          this.replayStatus = false;
        }
      } else {
        this.questionDisable = false;
        this.replayStatus = false;
      }
      this.ShowQuestion = true;
    },
    // 确认回复
    questionBtn(data, status, index) {
      let result = false;
      this.questionForm.disposelsit.forEach((el) => {
        if (el.disposecontent != null) {
          // 都不为空
          result = true;
        } else {
          // 有空数据
          this.$message.error("请填写完成数据!");
          result = false;
        }
        return result;
      });
      // result, true为不空,false为空
      if (result) {
        data.disposecontent = this.$refs.ck[index].ckeditor.getData();
        let params = {
          fbid: this.questionForm.id,
          projectid: this.$store.state.xid,
          type: 4,
          isclose: status,
          disposeid: data.id,
          strcontent: !status ? data.disposecontent : ''
        };
        let fd = new FormData();
        for (var key in params) {
          fd.append(key, params[key]);
        }
        YWFbAskedAndReply(fd).then((res) => {
          if (res.Code != 0) {
            this.$message.success("操作成功");
            this.ShowQuestion = false;
            this.replayStatus = true;
            this.questionDisable = true;
            this.GetFeedbackList();
          } else {
            this.$message.error("操作失败");
          }
        });
      }
    },
    // 追问
    continueBtn(data) {
      this.newFeedback = {
        id: 0,
        feedbackid: this.questionForm.id,
        fbcontent: "",
      };
      this.zwStatus = false;
    },
    // 追问回复
    questionBtn1() {
      this.newFeedback.fbcontent = this.$refs.ck2.ckeditor.getData();
      let params = {
        fbid: this.newFeedback.feedbackid,
        projectid: this.$store.state.xid,
        type: 4,
        isclose: false,
        disposeid: 0,
        strcontent: this.newFeedback.fbcontent,
      };
      let fd = new FormData();
      for (var key in params) {
        fd.append(key, params[key]);
      }
      YWFbAskedAndReply(fd).then((res) => {
        if (res.Code != 0) {
          this.$message.success("操作成功");
          this.ShowQuestion = false;
          this.zwStatus = true;
          this.GetFeedbackList();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    //下载
    downChange(data) {
      let name = data.fname.slice(data.fname.lastIndexOf("/") + 1);
      try {
        download(
          this.$store.state.baseUrl + data.fpath,
          name + data.fpath.substr(data.fpath.lastIndexOf("."))
        );
      } catch (error) {
        this.$message.error("导出失败");
      }
    },
    // 删除
    delChange(id) {
      this.$confirm("此操作将移除所选文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: id,
        };
        DelYwFilesList(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "移除成功!",
            });
          }
          this.getDataList();
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
        });
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.popularType-main {
  width: 100%;
  height: calc(100% - 10px);
  padding-top: 10px;

  .popularType_content {
    width: 100%;
    height: 100%;

    .content_left {
      width: 25%;
      height: 100%;
      margin: 15px;
    }

    .content_center {
      width: 70%;
      height: 100%;
    }
  }

  .wirte {
    color: #fff;
    font-size: 13px;
  }

  .flex {
    width: 100%;
  }

  .menuStyle {
    background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    padding: 0px 40px;
    box-sizing: content-box;
    width: 14%;
    height: 100%;
    color: #fff;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .isActive {
    background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
  }

  .content_style {
    width: 100%;
    height: 33%;

    .style_title {
      background-image: url("../../../assets/img/A三期/大屏/min.png");
      background-repeat: no-repeat;
      background-size: 120% 100%;
      font-size: 14px;
      padding: 10px 55px;
      font-weight: bold;
      color: #fff;
    }

    .style_content {
      height: calc(100% - 74px);
      margin-top: 10px;
      background-color: rgba(0, 133, 247, 0.1);
      width: calc(100% -20px);
      padding: 10px;
      color: #fff;

      .bj_1 {
        background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        text-align: center;
        font-weight: bold;
        width: 40%;
        height: 30%;
      }

      .bj_2 {
        background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 10% center;
        text-align: center;
        font-weight: bold;
        padding: 8px;
        letter-spacing: 5px;
        font-size: 20px;
        text-align: center;
        color: #04e8f8;
        font-family: "fzfs" !important;
      }

      .tian {
        position: relative;

        &::after {
          position: absolute;
          content: "天";
          right: -30%;
          color: #fff;
          bottom: 2px;
        }
      }
    }
  }

  .style_title2 {
    background-image: url("../../../assets/img/A三期/大屏/min.png");
    background-repeat: no-repeat;
    background-size: 50% 100%;
    font-family: "fzfs";
    font-size: 14px;
    padding: 10px 65px;
    font-weight: bold;
    color: #fff;
  }

  .carouselImg {
    position: absolute;
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 18px;
    font-family: YOUSHEBIAOTIHEI-2;
    background: linear-gradient(90deg,
        rgba(0, 133, 247, 0.2) 0%,
        rgba(0, 133, 247, 0.6) 51.56%,
        rgba(0, 133, 247, 0.2) 100%);

    z-index: 9;
  }

  //去除整体背景色
  .el-table,
  .el-table__expanded-cell {
    background-color: transparent !important;
    color: #3c9def;
  }

  .el-table::before {
    //去除底部白线
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 0px !important;
  }

  //修改行内线
  .el-table td,
  .building-top .el-table th.is-leaf,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid transparent;
  }

  //修改高度
  ::v-deep .el-table .cell {
    line-height: 20px;
    // margin-left: 15px;
  }

  .el-table .el-table__cell.gutter {
    background-color: #053e72 !important;
  }

  //修改行背景
  .el-table .el-table__row {
    background-image: url("../../../assets/img/Wisdom/Group\ 307.png");
    background-repeat: no-repeat;
    background-size: 100% 80%;
    background-position: center;
    background-color: transparent !important;
  }

  /* 用来设置当前页面element全局table 选中某行时的背景色*/
  .el-table__body tr.current-row>td {
    background-color: transparent !important;
  }

  .el-table__body tr.current-row {
    background-image: url("../../../assets/img/Wisdom/Group\ 327.png");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }

  //鼠标悬停
  .el-table tbody tr:hover>td {
    background-color: #44525f !important;
    color: #fff;
  }

  /deep/ .el-table__empty-text {
    color: #fff;
  }

  // 走马灯--图标改变
  .swiper {
    width: 80%;
    height: 100%;
  }

  .el-carousel__container {
    height: 100%;
  }

  .left-img1 {
    margin-right: 5px;
    cursor: pointer;
  }

  .right-img1 {
    margin-left: 5px;
    cursor: pointer;
  }

  .el-carousel__arrow--left,
  .el-carousel__arrow--right {
    display: none;
  }

  .el-carousel__item {
    width: 100%;

    .carousek {
      width: 100%;

      .carousel_Title {
        width: 100%;
        height: 40px;
        margin-top: 10px;
        font-size: 15px;
        justify-content: flex-start;
        padding-left: 10px;
        background-image: url("../../../assets/img/Intelligence/Group\ 2091.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        /* 设置背景图片的位置以及重复方式 */
        background-position: center top;
      }

      .carousel_content {
        height: 55%;
        margin-top: 10px;

        .content_mian {
          width: 80%;
          height: 70%;
          margin-left: 10px;
          font-size: 12px;
        }
      }
    }
  }

  ::v-deep .inputStyle .el-input.is-disabled .el-input__inner {
    color: #ccc !important;
  }

  ::v-deep .inputStyle .el-input .el-input__inner {
    color: #333 !important;
    /* 修改为你想要的颜色 */
  }

  /deep/.inputStyle .el-input.is-disabled .el-input__inner {
    color: #ccc !important;
  }

  /deep/.inputStyle .el-input .el-input__inner {
    color: #333 !important;
    /* 修改为你想要的颜色 */
  }

  /deep/.inputStyle .el-input.is-disabled .el-input__inner {
    color: #ccc !important;
  }

  /deep/.inputStyle .el-input .el-input__inner {
    color: #333 !important;
    /* 修改为你想要的颜色 */
  }

  .font_col2 {
    margin-left: 10px;
    color: #4edce1;
  }

  .imgorimgstyle {
    width: 100%;
    height: 500px;
    object-fit: fill;
    border-radius: 6px;
    pointer-events: auto;
  }
}
</style>
